import axiosInstance from 'axios'
import qs, { StringifyOptions } from 'query-string'

import { EDITOR_SERVICE_BASE_URL } from '../../api/config'
import { authTokenInterceptor, editorTokenInterceptor } from './interceptors'

const axios = axiosInstance.create({
  baseURL: EDITOR_SERVICE_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  paramsSerializer: params => {
    const opts: StringifyOptions = {
      arrayFormat: 'comma',
      skipEmptyString: true,
      skipNull: true
    }
    return qs.stringify(params, opts)
  }
})

axios.interceptors.request.use(authTokenInterceptor())
axios.interceptors.request.use(editorTokenInterceptor())

export default axios
